import { useState, useEffect } from 'react'

export default function ClientOnly({ children }) {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  // Returns null during SSR and initial hydration matching
  if (!hasMounted) return null

  return children
}
